import React, { useCallback, useMemo, useState } from "react";
import submit from "submit-form";
import PropTypes from "prop-types";
import Modal from "../../../../parts/modal-new";
import { SearchDropdown } from "../../../../parts/inputs/search-dropdown";

const HandleMealPlanTemplateModal = ({ locals }) => {
  const { query, mealPlanTemplates } = locals;
  const { templateId } = query;
  const currentTemplate = mealPlanTemplates.find(
    ({ _id }) => _id === templateId
  ) || {
    title: "",
    description: "",
  };
  const {
    title: currentTemplateTitle,
    description: currentTemplateDescription,
  } = currentTemplate;
  const titleModal = templateId
    ? "Edit Meal Plan Template"
    : "New Meal Plan Template";
  const buttonText = templateId ? "Edit Meal Plan" : "Create Meal Plan";

  const initialState = {
    title: currentTemplateTitle || "",
    description: currentTemplateDescription || "",
  };

  const [state, setState] = useState(initialState);

  const { title, description, numberOfWeeks } = state;

  const weeksOptions = Array.from({ length: 12 }, (_, i) => ({
    label: i + 1,
    value: i + 1,
  }));

  const isButtonDisabled = useMemo(() => {
    if (title.length === 0 || description.length === 0) return true;
    if (!Boolean(templateId)) return !numberOfWeeks;
    return false;
  }, [title, description, templateId, numberOfWeeks]);
  
  /**
   * Update the state
   * @param {*} newState
   * @returns
   */
  const updateState = (newState) =>
    setState((prevState) => ({ ...prevState, ...newState }));

  /**
   * Create a template with the same meal plan information
   */
  const handleSubmit = () => {
    const isEditing = Boolean(templateId);
    const body = {
      title: String(title),
      description: String(description),
      ...(!isEditing && { numberOfWeeks: parseInt(numberOfWeeks) }),
    };

    const url = isEditing
      ? `/actions/meal-planner/update-meal-plan?mealPlanId=${templateId}&proxyAthlete=${undefined}`
      : "/actions/meal-planner/create-new-template";

    submit(url, {
      method: "POST",
      body,
    });
  };

  /**
   * Get the input values
   * @param {*} e
   */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    updateState({ [name]: value });
  };

  return (
    <Modal
      className="handle-meal-plan-template"
      title={titleModal}
      toClear={["templateId"]}
    >
      <div className="body">
        <div className="inputs">
          <div>
            <label className="label" htmlFor="title">
              Plan name
            </label>
            <input
              type="text"
              placeholder="Enter plan name"
              name="title"
              value={title}
              onChange={handleInputChange}
              maxLength={60}
            />
          </div>
          <div>
            <label className="label" htmlFor="description">
              Description
            </label>
            <textarea
              name="description"
              className="textarea-input"
              placeholder="Enter description here"
              value={description}
              onChange={handleInputChange}
              maxLength={100}
            ></textarea>
          </div>
          {!templateId && (
            <div>
              <label>Number of weeks</label>

              <SearchDropdown
                name="weeks"
                options={weeksOptions}
                handleChange={({ value }) =>
                  updateState({ numberOfWeeks: value })
                }
                value={numberOfWeeks}
                valueKey="label"
              />
            </div>
          )}
        </div>

        <div className="buttons justify-end">
          <button
            data-button-type="primary"
            onClick={handleSubmit}
            disabled={isButtonDisabled}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default HandleMealPlanTemplateModal;

HandleMealPlanTemplateModal.propTypes = {
  locals: PropTypes.object,
};
